module.exports = __webpack_public_path__ + "media/hyper/images/payments/american-express-fd39e4d0819b2dc119faaba7e23fa16e.png";